import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconCinema$1 = /*@__PURE__*/ proxyCustomElement(class WppIconCinema extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-cinema", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.25 6.25C14.25 7.36815 13.7606 8.37201 12.9844 9.05905C13.4537 9.47142 13.75 10.0761 13.75 10.75V10.8431L16.8562 9.51186C17.5161 9.22906 18.2501 9.71309 18.2501 10.431V15.6727C18.2501 16.3907 17.5161 16.8747 16.8562 16.5919L13.75 15.2606C13.7442 16.4984 12.7391 17.5 11.5 17.5H4.25C3.00736 17.5 2 16.4926 2 15.25V10.75C2 10.0437 2.32544 9.41342 2.83454 9.00091C2.31667 8.44321 2 7.69609 2 6.875C2 5.14911 3.39911 3.75 5.125 3.75C5.90904 3.75 6.62565 4.03874 7.17428 4.51568C7.8003 3.31768 9.05466 2.5 10.5 2.5C12.5711 2.5 14.25 4.17893 14.25 6.25ZM10.5 4C9.25736 4 8.25 5.00736 8.25 6.25C8.25 7.49264 9.25736 8.5 10.5 8.5C11.7426 8.5 12.75 7.49264 12.75 6.25C12.75 5.00736 11.7426 4 10.5 4ZM5.125 8.5C6.02246 8.5 6.75 7.77246 6.75 6.875C6.75 5.97754 6.02246 5.25 5.125 5.25C4.22754 5.25 3.5 5.97754 3.5 6.875C3.5 7.77246 4.22754 8.5 5.125 8.5ZM4.25 10C3.83579 10 3.5 10.3358 3.5 10.75V15.25C3.5 15.6642 3.83579 16 4.25 16H11.5C11.9142 16 12.25 15.6642 12.25 15.25V10.75C12.25 10.3358 11.9142 10 11.5 10H4.25ZM13.75 12.475V13.6287L16.7501 14.9145V11.1893L13.75 12.475Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-cinema-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-cinema", "wpp-icon-cinema-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-cinema-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-cinema-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconCinema$1);
      }
      break;
  } });
}

const WppIconCinema = WppIconCinema$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconCinema, defineCustomElement };
